var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGraphAverage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2499 17.143C14.9357 17.143 14.0164 14.4584 13.1273 11.8625C12.2852 9.40168 11.4128 6.85725 9.53566 6.85725C9.09735 6.88302 8.67664 7.03869 8.32712 7.30441C7.9776 7.57013 7.71508 7.93388 7.57302 8.34932L6.35352 7.93982C6.3863 7.84339 7.17059 5.57153 9.53566 5.57153C12.3321 5.57153 13.4005 8.6926 14.3442 11.446C15.1214 13.7146 15.8549 15.8572 17.2499 15.8572C17.6882 15.8315 18.109 15.6758 18.4585 15.4101C18.808 15.1444 19.0705 14.7806 19.2126 14.3652L20.4314 14.7747C20.3993 14.8711 19.615 17.143 17.2499 17.143Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03571 19.7143V12.6429H6.32143V11.3571H5.03571V3H3.75V19.7143C3.75 20.0553 3.88546 20.3823 4.12658 20.6234C4.3677 20.8645 4.69472 21 5.03571 21H21.75V19.7143H5.03571Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60742 11.3572H8.89314V12.6429H7.60742V11.3572Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1777 11.3572H11.4634V12.6429H10.1777V11.3572Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3223 11.3572H16.608V12.6429H15.3223V11.3572Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8926 11.3572H19.1783V12.6429H17.8926V11.3572Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4648 11.3572H21.7506V12.6429H20.4648V11.3572Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGraphAverage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GraphAverage.66eb4494.svg";
export { ForwardRef as ReactComponent };